export type FeatureFlag = 'ui_ledger'

type FlagMap = Partial<Record<FeatureFlag, boolean>>

/**
 * Feature flags come from public/env.js (`FEATURE_FLAGS`), which ops can change per
 * environment without a rebuild. A `?<flag>=0|1` query param overrides it for this
 * browser tab, which is how QA toggles the flag in staging.
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  try {
    const override = new URLSearchParams(window.location.search).get(flag)
    if (override === '1' || override === '0') {
      sessionStorage.setItem(`ff.flag.${flag}`, override)
    }
    const stored = sessionStorage.getItem(`ff.flag.${flag}`)
    if (stored === '1') return true
    if (stored === '0') return false
  } catch {
    // storage unavailable: fall through to env
  }
  const flags = (window.__FULFILLMENT_PANEL_ENV__ as { FEATURE_FLAGS?: FlagMap } | undefined)?.FEATURE_FLAGS
  return flags?.[flag] ?? true
}

export function useFeatureFlag(flag: FeatureFlag): boolean {
  return isFeatureEnabled(flag)
}
